import React, { useContext, useState } from 'react';
import Page from 'layout/Page/Page';
import PageWrapper from 'layout/PageWrapper/PageWrapper';
import './mobile.scss';
// Icons (same icons you already use)
import AddIcon from 'assets/customizeIcons/AddIcon.svg';
import DechargeIcon from 'assets/customizeIcons/DechargeIcon.svg';
import { ReactComponent as CalendarIcon } from 'assets/customizeIcons/Calendar.svg';
import { ReactComponent as SvgEditIcon } from 'assets/customizeIcons/EditSquare.svg';
import { ReactComponent as InfoIcon } from 'assets/customizeIcons/InfoIcon.svg';
import { ReactComponent as ListIcon } from 'assets/customizeIcons/ListIcon.svg';
import { ReactComponent as MoneyDollarIcon } from 'assets/customizeIcons/MoneyDollar.svg';
import { ReactComponent as UserCircleIcon } from 'assets/customizeIcons/UserCircleIcon.svg';
import TimeIcon from 'assets/customizeIcons/TimeIcon';
import moment from 'moment';
import CreateDevisModal from './CreateDevisModal';
import { formatCurrency } from 'pages/comptabilite/utils/functions';
import { usePlanningData } from './hooks/usePlanningData';
import AuthContext from 'contexts/authContext';
import UpdateDevisLineModal from './UpdateDevisLineModal';
import UpdateDevisModal from './UpdateDevisModal';
import RapportTabMobile from './RapportTabMobile';
import ClientTabMobile from './ClientTabMobile';
import PaiementTabMobile from './PaiementTabMobile';
import SingleAttahcement from 'components/Attachements/SingleAttahcement';
import DisplayHEICImage from 'components/Attachements/DisplayHEICImage';
import { Row, Spinner } from 'react-bootstrap';
import { useLogicProduit } from 'pages/Stock/hooks/useLogicProduit';
import { useLogicDevis } from 'pages/Devis/hooks/useLogicDevis';
import { getTaxInfo } from 'common/function/functionsUtils';
import GoogleReviewQR from './GoogleReviewQR';

// import CutomizedHeader from 'components/CutomizedHeader';

// Theme
// import argonTheme from 'theme/theme';
export const COLORS = {
	DEFAULT: '#172B4D',
	PRIMARY: '#6c5dd3',
	SECONDARY: '#ffa2c0',
	LABEL: '#FE2472',
	INFO: '#4d69fa',
	ERROR: '#f35421',
	SUCCESS: '#46bcaa',
	WARNING: '#ffcf52',
	/*not yet changed */
	MUTED: '#ADB5BD',
	INPUT: '#DCDCDC',
	INPUT_SUCCESS: '#7BDEB2',
	INPUT_ERROR: '#FCB3A4',
	ACTIVE: '#5E72E4', //same as primary
	BUTTON_COLOR: '#9C26B0', //wtf
	PLACEHOLDER: '#9FA5AA',
	SWITCH_ON: '#5E72E4',
	SWITCH_OFF: '#D4D9DD',
	GRADIENT_START: '#6B24AA',
	GRADIENT_END: '#AC2688',
	PRICE_COLOR: '#EAD5FB',
	BORDER_COLOR: '#E7E7E7',
	BLOCK: '#E7E7E7',
	ICON: '#172B4D',
	HEADER: '#525F7F',
	BORDER: '#CAD1D7',
	WHITE: '#FFFFFF',
	BLACK: '#000000',
	LABEL: '#6c757d',
	GRAY: '#7a7a7a',
	INPUT_BG: '#f9f9f9',
	BG_L10_ERROR: '#feeee9',
	BG_L10_PRIMARY: '#f0effb',
	BG_L10_WARNING: '#fff1cb',
	BG_L10_SUCCESS: '#d4edda',
	BG_L10_INFO: '#c9d2fd',
	BG_L10_DARK: '#d6d8d9',
	BG_L10_SECONDARY: '#f2d3e3',
	BG_L10_DEFAULT: '#172B4D33',
	BG_L25_PRIMARY: '#dad7f4',
	BG_L25_INFO: '#d3dafe',
	BG_L25_SECONDARY: '#ffe8ef',
	BG_L25_SUCCESS: '#d1eeea',
	BG_L25_DEFAULT: '#f8f9fe',
	BG_L25_WARNING: '#fff7e6',
	BG_L25_ERROR: '#fff0ec',
	BG_L25_DARK: '#e2e2e2',
	BG_L25_BLACK: '#f5f5f5',
	BG_L25_GRAY: '#f9f9f9',
	BG_L25_WHITE: '#f8f8f8',
	BG_L75_DEFAULT: '#edf2fa',
	BG_L75_INFO: '#edf0ff',
	BG_L75_SUCCESS: '#edf8f7',
	BG_L75_PRIMARY: '#f0effb',
	BG_L75_WARNING: '#fffaee',
	BG_L75_ERROR: '#feeee9',
	BG_PAGES: '#FFFFFF',
	BG_SIMULATOR: '#f1f1f1',
	BG_L75_GRAY: '#f5f5f5',
	BG_WHITE: '#ffffff2b',
};

export const statut = {
	brouillon: 'Brouillon',
	envoyé: 'Envoyé',
	accepté: 'Accepté',
	refusé: 'Refusé',
};

function Mobile({ interventionData, setInterventionData, activeTab, setActiveTab }) {
	const { updateIntervention } = usePlanningData();
	const { userData } = useContext(AuthContext);
	console.log("interventionData", interventionData)
	const tabs = [
		{
			key: 'first',
			title: 'Détails',
			icon: InfoIcon,
			component: <InterventionDetails interventionData={interventionData} />,
		},
		{
			key: 'second',
			title: 'Client',
			icon: UserCircleIcon,
			component: (
				<ClientTabMobile
					clientData={interventionData?.client}
					setInterventionData={setInterventionData}
				/>
			),
		},
		{
			key: 'third',
			title: 'Devis',
			icon: ListIcon,
			component: (
				<DevisTab
					interventionData={interventionData}
					AddDevis={async (newDevis) => {
						const fullUpdateData = {
							rapport_intervention: {
								...interventionData?.rapport_intervention,
								devis: [
									...(interventionData?.rapport_intervention?.devis || []).map(
										(i) => i?._id,
									),
									newDevis?._id,
								].filter(Boolean),
							},

							updatedBy: userData?.id,
							performedBy: userData?.id,
						};

						await updateIntervention(interventionData?._id, fullUpdateData);

						setInterventionData((prev) => ({
							...prev,
							rapport_intervention: {
								...prev.rapport_intervention,
								devis: [newDevis, ...(prev?.rapport_intervention?.devis || [])],
							},
						}));
					}}
					UpdateDevis={async (newDevis) => {
						if (!newDevis?._id) return;

						setInterventionData((prev) => {
							const devisList = prev?.rapport_intervention?.devis || [];

							const newList = devisList.map((d) =>
								d?._id === newDevis._id ? newDevis : d,
							);

							return {
								...prev,
								rapport_intervention: {
									...prev.rapport_intervention,
									devis: newList,
								},
							};
						});
					}}
					// --- NEW DELETE FUNCTION ---
					DeleteDevis={async (devisId) => {
						if (!devisId) return;

						// 1. Prepare data for the API (send only the remaining IDs)
						const remainingIds = (interventionData?.rapport_intervention?.devis || [])
							.map((d) => d?._id)
							.filter((id) => id !== devisId && id);

						const fullUpdateData = {
							rapport_intervention: {
								...interventionData?.rapport_intervention,
								devis: remainingIds,
							},
							updatedBy: userData?.id,
							performedBy: userData?.id,
						};

						// 2. Update Backend
						await updateIntervention(interventionData?._id, fullUpdateData);

						// 3. Update Local State
						setInterventionData((prev) => ({
							...prev,
							rapport_intervention: {
								...prev.rapport_intervention,
								devis: (prev?.rapport_intervention?.devis || []).filter(
									(d) => d?._id !== devisId
								),
							},
						}));
					}}
				/>
			),
		},
		{
			key: 'fourth',
			title: 'Rapport',
			icon: SvgEditIcon,
			component: (
				<RapportTabMobile
					interventionData={interventionData}
					setInterventionData={setInterventionData}
				/>
			),
		},
		{
			key: 'fifth',
			title: 'Paiement',
			icon: MoneyDollarIcon,
			component: (
				<PaiementTabMobile
					paiementData={interventionData?.rapport_intervention?.paiements}
					setInterventionData={setInterventionData}
					interventionData={interventionData}
				/>
			),
		},
		// { key: 'sixth', title: 'Décharge', icon: DechargeIcon },

	];

	return (
		<div>

			{/* ===== TABS ===== */}
			<div className='tabs-layout'>
				<div className='tabs-header sticky-top'>
					{tabs.map((tab) => {
						const isActive = activeTab === tab.key;
						const Icon = tab.icon;
						return (
							<button
								key={tab.key}
								className={`tab-item ${isActive ? 'active' : ''}`}
								onClick={() => setActiveTab(tab.key)}>
								<Icon
									style={{
										width: '26px',
										height: '26px',
										marginBottom: '4px',
										fill: isActive && COLORS.PRIMARY
									}}
									className="tab-icon"
								/>

								<span className='tab-label'>{tab.title}</span>
							</button>
						);
					})}
				</div>

				<div className='tabs-content'>
					{tabs.find((t) => t.key === activeTab)?.component}
				</div>
			</div>
		</div>
	);
}

export default Mobile;

function InterventionDetails({ interventionData }) {
	const topDetails = [
		{
			title: 'Date',
			icon: <CalendarIcon fill={COLORS.PRIMARY} width={20} height={20} />,
			value: moment(interventionData?.date_debut)?.format('DD MMMM'),
			color: 'SECONDARY',
		},
		{
			title: 'Début',
			icon: <TimeIcon size={20} color={COLORS.PRIMARY} />,
			value: moment(interventionData?.date_debut)?.format('HH:mm'),
			color: 'SUCCESS',
		},
		{
			title: 'Fin',
			icon: <TimeIcon size={20} color={COLORS.PRIMARY} />,
			value: moment(interventionData?.date_fin)?.format('HH:mm'),
			color: 'INFO',
		},
	];
	return (
		<div className='details-container'>
			<style>{`
				.details-top {
					display: flex;
					justify-content: space-evenly;
					flex-wrap: wrap;
					margin-bottom: 30px;
				}

				.detail-card {
					background: ${COLORS.BG_L75_PRIMARY};
					border-radius: 20px;
					width: 30%;
					height: 60px;
					display: flex;
					flex-direction: column;
					justify-content: space-evenly;
					align-items: center;
				}

				.detail-title {
					font-size: 12px;
					color: ${COLORS.PRIMARY};
					font-weight: 500;
				}

				.detail-value {
					display: flex;
					align-items: center;
					gap: 6px;
					font-size: 14px;
					font-weight: 600;
					color: ${COLORS.PRIMARY};
				}

				.detail-icon {
					width: 20px;
					height: 20px;
				}

				.section {
					margin-bottom: 30px;
				}

				.section-title {
					font-weight: 600;
					color: ${COLORS.DEFAULT};
					margin-bottom: 10px;
				}

				.attachments {
					display: flex;
					flex-wrap: wrap;
					gap: 12px;
				}

				.attachment-card {
					width: 200px;
					height: 250px;
					border: 1px solid #ddd;
					border-radius: 8px;
					background: #fff;
					cursor: pointer;
				}

				.empty-text {
					color: #777;
				}
			`}</style>
			{!!interventionData?.companyId?.fiche && <GoogleReviewQR intervention={interventionData} />}
			{/* ===== TOP DETAILS ===== */}
			<div className='details-top'>
				{topDetails.map((item, index) => (
					<div key={index} className='detail-card'>
						<div className='detail-title'>{item.title}</div>

						<div className='detail-value'>
							{item.icon}
							<span style={{ fontSize: '12px' }}>{item.value}</span>
						</div>
					</div>
				))}
			</div>

			{/* ===== DESCRIPTION ===== */}
			<div className='section'>
				<div className='section-title'>Remarques</div>

				{!!interventionData?.notes?.length ? (
					interventionData.notes.map((note, index) => (
						<div key={index} className='note-item'>
							{/* Meta */}
							<div className='note-meta'>
								<small className='note-author text-muted '>
									Par <strong>{note?.createdBy?.name || '—'}</strong>
								</small>
							</div>

							{/* Content */}
							<div
								className='note-content'
								dangerouslySetInnerHTML={{
									__html: note?.note,
								}}
							/>
						</div>
					))
				) : (
					<div className='empty-text'>Aucune description</div>
				)}
			</div>

			{/* ===== ATTACHMENTS ===== */}
			<div className='section'>
				<div className='section-title'>Pièces jointes</div>

				{interventionData?.attachments?.length ? (
					<Row className='g-3'>
						{interventionData.attachments.map((file, index) => {


							return (
								<Attachements
									key={index}
									file={file}
									index={index}

								/>

							);
						})}
					</Row>
				) : (
					<div className='empty-text'>Aucune pièce jointe</div>
				)}
			</div>
		</div>
	);
}

function DevisTab({ interventionData, UpdateDevis, AddDevis, DeleteDevis }) {
	const devisList = [...(interventionData?.rapport_intervention?.devis || [])];
	console.log("interventionData", interventionData?.companyId)
	const [openDecharge, setOpenDecharge] = useState(false);
	const [modalVisible, setModalVisible] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [currentFormValue, setCurrentFormValue] = useState({});
	const [error, setError] = useState(false);
	const [devisModel, setDevisModel] = useState(false);
	const [selectedDevis, setSelectedDevis] = useState({});
	const [sendLoading, setSendLoading] = useState(false);
	const [success, setSuccess] = useState(false);
	const [createDevisModel, setCreateDevisModel] = useState(false);
	const { userData } = useContext(AuthContext);
	const { createDevis } = useLogicDevis();
	const { taxes, defaultTax } = getTaxInfo(interventionData?.companyId?.address?.country);

	const handleCreateDevis = async () => {
		// setSpinner(true);
		setIsLoading(true)
		const technicienIds =
			interventionData?.cars
				?.flatMap((car) => (car?.conducteurs || []).map((c) => c?.technicien))
				?.map((t) => t?._id || t?.id)
				?.filter(Boolean) || [];
		const payload = {
			clientId: interventionData?.client?._id,
			companyId: interventionData?.companyId?._id || interventionData?.cars[0]?.companyId,
			createdBy: userData?.id,
			dateValidite: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
				.toISOString()
				.split('T')[0],
			name: 'devis ' + interventionData?.client?.nom + ' ' + interventionData?.reference,
			// lignes: data?.lignes,
			tva: defaultTax,
			technicienIds,
			motif: interventionData?.motif,
			origin: 'technicien',
			interventionId: interventionData?._id || interventionData?.id
		};
		const resultDevis = await createDevis(payload);
		AddDevis(resultDevis?.data);
		setSelectedDevis(resultDevis?.data);
		setIsLoading(false)

		setDevisModel(true);
	};

	return (
		<div className='devis-container'>
			{/* HEADER */}
			<div className='devis-header'>
				<h3>Liste de devis</h3>

				<button className='btn-create' onClick={handleCreateDevis} disabled={isLoading}>
					{isLoading ? <><Spinner animation="border" size="sm" className="me-1" /> En cours </> :
						<><img src={AddIcon} width={35} height={35} />
							Créer un devis
						</>}
				</button>
			</div>

			{/* LIST */}
			{devisList.length ? (
				<div className='devis-list'>
					{devisList.map((item, idx) => (
						<div
							key={item?.id || idx}
							className='devis-clickable'
							onClick={() => {
								setSelectedDevis(item);
								setDevisModel(true);
							}}>
							<DevisCard item={item} />
						</div>
					))}
				</div>
			) : (
				<div className='empty-text'>Aucun devis</div>
			)}

			{/* {!!devisModel && (
        <DevisModel defaultData={selectedDevis} setVisible={setDevisModel} />
      )} */}
			{/* {openDecharge && (
        <DechargeModal
          setVisible={setOpenDecharge}
          planning={interventionData}
        />
      )}
      {!!modalVisible && (
        <ConfirmationPopup
          yesFunction={handleStart}
          setModalVisible={setModalVisible}
          title={"Créer un devis ?"}
          isLoading={isLoading}
        />
      )}


*/}
			{!!devisModel && (
				<UpdateDevisModal
					devisData={selectedDevis}
					onClose={() => setDevisModel(false)}
					UpdateDevis={UpdateDevis}
					DeleteDevis={DeleteDevis}
					interventionData={interventionData}
					AddDevis={AddDevis}
					taxes={taxes}
				/>
			)}
			{!!createDevisModel && (
				<CreateDevisModal
					interventionData={interventionData}
					onClose={() => setCreateDevisModel(false)}
					AddDevis={AddDevis}
				/>
			)}

		</div>
	);
}

function DevisCard({ item }) {
	const getDevisBackgroundColor = (item) => {
		const color =
			item?.statut == 'brouillon'
				? COLORS.BG_L75_PRIMARY
				: item.statut == 'envoyé'
					? COLORS.BG_L75_INFO
					: item.statut == 'accepté'
						? COLORS.BG_L75_SUCCESS
						: COLORS.BG_L75_ERROR;
		return color;
	};

	const getDevisColor = (item) => {
		const color =
			item?.statut == 'brouillon'
				? COLORS.PRIMARY
				: item.statut == 'envoyé'
					? COLORS.INFO
					: item.statut == 'accepté'
						? COLORS.SUCCESS
						: COLORS.ERROR;
		return color;
	};

	return (
		<div className='devis-card' style={{ background: getDevisBackgroundColor(item) }}>
			{/* TOP */}
			<div className='devis-row devis-top'>
				<div>
					<div className='devis-name'>{item?.reference}</div>
				</div>

				<div className='devis-state' style={{ color: getDevisColor(item) }}>
					{statut[item?.statut]}
				</div>
			</div>

			{/* AMOUNT */}
			<div className='devis-amount'>{formatCurrency(item?.totalTTC)}</div>

			{/* BOTTOM */}
			<div className='devis-row devis-bottom'>
				<div className='project-title'>{item?.name}</div>
			</div>
			<div className='devis-date mt-2'>
				<span>
					<CalendarIcon fill={COLORS.DEFAULT} width={20} height={20} />
					{moment(item?.date_order).format('DD MMMM')}
				</span>
				<span>
					<TimeIcon size={20} color={COLORS.DEFAULT} />{' '}
					{moment(item?.date_order).format('HH:mm')}
				</span>
			</div>
		</div>
	);
}


function Attachements({ file, index, deleteImage = () => { } }) {
	const isImage = file?.mimeType?.startsWith('image/');
	const fileUrl = `/coreService/${file.path}`;
	const theFile = file;
	const fileType = theFile?.mimeType

	const src =
		"/coreService/" + theFile?.path

	console.log("theFile", theFile)

	if (fileType?.toLowerCase() === 'heic') {
		return (
			<DisplayHEICImage src={src} theFile={theFile} index={index} deleteImage={deleteImage} />
		);
	}

	if (/image|jpeg|jpg|png|ico/i.test(fileType)) {
		return (
			<SingleAttahcement
				src={src}
				index={index}
				name={theFile?.originalName}
				deleteImage={deleteImage}>
				<img
					src={src}
					alt={theFile?.originalName}
					style={{
						objectFit: 'contain',
						width: '100%',
						height: '100%',
					}}
				/>
			</SingleAttahcement>
		);
	} else if (
		fileType === 'video' ||
		fileType === 'mp4' ||
		fileType?.toLowerCase() === 'mov' ||
		fileType?.toLowerCase() === 'mkv'
	) {
		return (
			<SingleAttahcement
				src={src}
				index={index}
				name={theFile?.originalName}
				deleteImage={deleteImage}>
				<video
					controls
					style={{
						objectFit: 'fill',
						width: '100%',
						height: '100%',
					}}>
					<source src={src} type={file.type} />
				</video>
			</SingleAttahcement>
		);
	} else if (
		fileType === 'application' || fileType === 'application/pdf' ||
		fileType === 'pdf'
	) {
		return (
			<SingleAttahcement
				src={src}
				index={index}
				name={theFile?.originalName}
				deleteImage={deleteImage}>
				<embed
					src={src}
					type='application/pdf'
					style={{
						objectFit: 'fill',
						width: '100%',
						height: '100%',
					}}
				/>
			</SingleAttahcement>
		);
	} else {
		return (
			<SingleAttahcement
				src={src}
				index={index}
				name={theFile?.originalName}
				deleteImage={deleteImage}>
				{/* <embed
					src={src}
					type='application/pdf'
					style={{
						objectFit: 'fill',
						width: '100%',
						height: '100%',
					}}
				/> */}
				<span>Desolé! Type de ficher non reconnu!</span>
			</SingleAttahcement>
		);
	}
}

